import * as React from 'react'

export interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbsContextValue {
  items: BreadcrumbItem[]
  setItems: (items: BreadcrumbItem[]) => void
}

const BreadcrumbsContext = React.createContext<BreadcrumbsContextValue>({
  items: [],
  setItems: () => {},
})

export function BreadcrumbsProvider({ children }: { children: React.ReactNode }) {
  const [items, setItems] = React.useState<BreadcrumbItem[]>([])
  return (
    <BreadcrumbsContext.Provider value={{ items, setItems }}>
      {children}
    </BreadcrumbsContext.Provider>
  )
}

export function useBreadcrumbs(items: BreadcrumbItem[]) {
  const { setItems } = React.useContext(BreadcrumbsContext)
  React.useLayoutEffect(() => {
    setItems(items)
    return () => setItems([])
    // Stringify to compare by value
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(items)])
}

export function useBreadcrumbItems(): BreadcrumbItem[] {
  return React.useContext(BreadcrumbsContext).items
}
